import { Outlet } from "react-router-dom";
import Sidebar from "@components/SideBar.jsx";
import TopNav from "@components/TopNav.jsx";
import { MobileNavProvider } from "@/utils/MobileNavContext.jsx";

const Layout = () => (
    <MobileNavProvider>
        <div className="app-shell">
            <TopNav />
            <div className="app">
                <Sidebar />
                <main className={`content`}><Outlet /></main>
            </div>
        </div>
    </MobileNavProvider>
);

export default Layout;
